import request from '@/utils/request'
export function aboutInfo(data) {
    return request({
        url: '/aboutinfo',
        method: 'get',
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export function aboutInfoUpdate(data) {
    return request({
        url: '/aboutinfo/update',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
